import RestrictedRoute from '../../../common/route/restrictedRoute';
import React from 'react';
import CommonReport from './StandardReport';
import { REPORTS_LIST } from './StandardReportConfig';

const StandardReportsRoutes = () => {
  return REPORTS_LIST.map(report =>
    <RestrictedRoute
      exact
      key={report.reportName}
      fields={report.fields}
      reportName={report.reportName}
      reportTitle={report.reportTitle}
      isSieEnabled={report.isSieEnabled}
      path={report.urlPath}
      component={CommonReport}
    />);
};

export default StandardReportsRoutes;